export default () => {
  const indicators = [
    { key: "stochrsi", name: "Stochastic Rsi" },
    {
      key: "rsi",
      name: "Relative Strength Index",
      parameters: { in_0: 14 },
      styles: { "%d.color": "#FF0000" },
    },
    {
      key: "macd",
      name: "MACD",
      parameters: { in_0: 14, in_1: 30, in_3: "close", in_2: 9 },
    },
    {
      key: "bb",
      name: "Bollinger Bands",
      parameters: { in_0: 20, in_1: 2 },
    },
    {
      key: "bb_squeeze",
      name: "Bollinger Bands",
      parameters: { in_0: 20, in_1: 2 },
    },
    {
      key: "sma",
      name: "Moving Average",
      parameters: { in_0: 7, in_1: "open" },
    },
    {
      key: "ema_crossover",
      name: "EMA Cross",
      parameters: { in_0: 8, in_1: 21 },
    },
    {
      key: "ema",
      name: "Moving Average Exponential",
      parameters: {
        length: 6,
        source: "open",
        offset: 0,
        smoothingLine: "EMA",
        smoothingLength: 9,
      },
    },
    { key: "ao", name: "Awesome Oscillator" },
    { key: "supertrend", name: "SuperTrend" },
    { key: "di", name: "Directional Movement" },
    { key: "mfi", name: "Money Flow Index" },
    { key: "ichimoku", name: "Ichimoku Cloud" },
    { key: "accumulation_distribution", name: "Accumulation/Distribution" },
    {
      key: "sma_crossover",
      name: "Moving Average",
      parameters: [{ length: 8 }, { length: 21 }],
      styles: [{ "%d.color": "#4CBB17" }, { "%d.color": "#FF5733" }],
    },
  ];
  const loadIndicators = (tvWidget, propsIndicators, $route) => {
    let queryIndicator = "";
    if (propsIndicators.length === 0 && $route.query.indicator.length) {
      queryIndicator = $route.query.indicator;
    }
    tvWidget.headerReady().then(function () {
      tvWidget.activeChart().removeAllStudies();
      let vol = tvWidget
        .activeChart()
        .getAllStudies()
        .find((i) => (i.name = "Volume"));
      if (!vol) tvWidget.activeChart().createStudy("Volume", true, true);

      const createStudy = (name, parameters = {}, styles = {}) => {
        tvWidget
          .activeChart()
          .createStudy(name, false, false, parameters, styles);
      };

      indicators.forEach(({ key, name }) => {
        if (propsIndicators.includes(key)) {
          createStudy(name);
        }
        if (queryIndicator.includes(key)) {
          createStudy(name);
        }
      });
    });
  };

  return { loadIndicators };
};
